module.exports = __webpack_public_path__ + "img/ZM.a7e7d66f.svg";